var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.cardRoute)?_c('router-link',{staticClass:"smallCard",attrs:{"to":_vm.cardRoute}},[_vm._v(" "+_vm._s(_vm.cardTitle)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }